import { render, staticRenderFns } from "./SupplierTypeFilter.vue?vue&type=template&id=470080b8&"
import script from "./SupplierTypeFilter.vue?vue&type=script&lang=js&"
export * from "./SupplierTypeFilter.vue?vue&type=script&lang=js&"
import style0 from "./SupplierTypeFilter.vue?vue&type=style&index=0&id=470080b8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports